import { SlidersHorizontal } from 'lucide-react'
import {
  agentSettings,
  callFacts,
  teamCodeTabs,
} from '@/features/agents-marketing/data/agentsContent'
import { CodeSample } from '@/features/home/components/CodeSample'
import { SectionHeading } from '@/features/home/components/SectionHeading'
import { Reveal } from '@/shared/components/Reveal'
import { useSpotlight } from '@/shared/hooks/useSpotlight'

export function BuilderSection() {
  const onPointerMove = useSpotlight()

  return (
    <section className="relative border-y border-[var(--color-border)] bg-[var(--color-bg-secondary)]/40 px-6 py-24 md:py-36">
      <div className="mx-auto max-w-6xl">
        <Reveal>
          <SectionHeading
            eyebrow="Builder"
            title="Build it on a canvas. Call it with one string."
            lede="Add a coordinator and specialists, configure each one where it sits, save. From then on the team id is a model id in your code."
          />
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-4 lg:grid-cols-12">
          <Reveal className="min-w-0 lg:col-span-7">
            <CodeSample tabs={teamCodeTabs} />
          </Reveal>

          <Reveal delay={0.08} className="lg:col-span-5">
            <article
              onPointerMove={onPointerMove}
              className="surface-bevel spotlight flex h-full flex-col rounded-[1.5rem] p-7"
            >
              <SlidersHorizontal
                aria-hidden
                className="size-4 text-primary"
                strokeWidth={1.75}
              />
              <h3 className="mt-5 text-title-sm font-semibold tracking-[-0.02em] text-[var(--color-text-primary)]">
                Configure each agent in place
              </h3>
              <p className="mt-2 text-body-sm leading-relaxed text-[var(--color-text-secondary)]">
                Select a node and its settings open beside the canvas. Drag
                nodes to lay the team out the way you think about it.
              </p>
              <ol className="mt-6 divide-y divide-[var(--color-border)] border-y border-[var(--color-border)] text-body-sm text-[var(--color-text-secondary)]">
                {agentSettings.map((item, i) => (
                  <li key={item} className="flex items-start gap-4 py-3">
                    <span className="w-5 shrink-0 pt-0.5 font-mono text-caption text-primary">
                      0{i + 1}
                    </span>
                    {item}
                  </li>
                ))}
              </ol>
            </article>
          </Reveal>
        </div>

        <Reveal delay={0.12}>
          <dl className="mt-16 grid grid-cols-1 divide-y divide-[var(--color-border)] border-y border-[var(--color-border)] sm:grid-cols-3 sm:divide-x sm:divide-y-0">
            {callFacts.map((fact) => (
              <div key={fact.label} className="py-8 sm:px-8 sm:first:pl-0 sm:last:pr-0">
                <dt className="flex items-baseline gap-3">
                  <span className="text-sheen text-5xl font-semibold tabular-nums tracking-[-0.05em]">
                    {fact.value}
                  </span>
                  <span className="text-body-sm font-medium text-[var(--color-text-primary)]">
                    {fact.label}
                  </span>
                </dt>
                <dd className="mt-3 text-body-sm leading-relaxed text-[var(--color-text-secondary)]">
                  {fact.body}
                </dd>
              </div>
            ))}
          </dl>
        </Reveal>
      </div>
    </section>
  )
}
